// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

// import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query";
import { City, Street } from "models/Constants";
import { getApiSLice } from "utils/getApiBaseQuery";

// interface ReportStatuses {
//   // Define the type for the response data
// }

export const constantsApiSliceDev = getApiSLice("dev").injectEndpoints({
  endpoints: (builder) => ({
    getCitiesList: builder.query<City[], void>({
      query: () => ({
        url: "/utils/getCityListForBo",
        method: "GET",
      }),
    }),
    getStreetsList: builder.query<Street[], void>({
      query: ({ cityCode }: { cityCode: number }) => {
        return {
          url: `/utils/getStreetListForBo?CityId=${cityCode}`,
          method: "GET",
        };
      },
    }),
    getCarDetailsFromTransportationOffice: builder.mutation({
      query: ({ licensePlateNumber }: { licensePlateNumber: string }) => {
        return {
          url: `/utils/GetCarDetailsForBo?licensePlateNumber=${licensePlateNumber}`,
          method: "GET",
        };
      },
    }),
  }),
});

export const {
  useGetCitiesListQuery,
  useGetStreetsListQuery,
  useGetCarDetailsFromTransportationOfficeMutation,
} = constantsApiSliceDev;
